define('TescoMobile_Customer/js/view/account/dashboard/manage-data',['uiComponent', 'ko', 'mage/storage', 'mage/url'], function (Component, ko, storage, urlBuilder) {
  "use strict";

  return Component.extend({
    defaults: {
      template: 'TescoMobile_Customer/account/dashboard/manage-data'
    },
    allowances: ko.observable([]),
    initialize: function () {
      const self = this;
      this._super();
      let serviceUrl = urlBuilder.build('/rest/V1/dashboard/allowance-details', {});
      return storage.get(serviceUrl).done(function (response) {
        self.allowances(response);
      });
    },
    convertToGb: function (mb) {
      return (mb / 1024).toFixed(2);
    }
  });
});

